import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.werkix.io";

const CanonicalUrl = () => {
  const { pathname } = useLocation();
  const path = pathname.endsWith("/") && pathname !== "/" ? pathname.slice(0, -1) : pathname;
  const canonical = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default CanonicalUrl;
